const cssClasses = {
    collectionSidebar: '.collection-sidebar',
    accordionHeading: '.accordion-heading',
    accordionContent: '.accordion-content',
    filterItem: '.collection-sidebar__filter-item',
    filter: '.collection-sidebar__filter-items',
};

// Accordion
const accordionHeading = $(cssClasses.accordionHeading);

var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination',
    method: 'click',
    offset: 150,
    beforeLoad: function () {
        $('.collection__main').addClass('ajax-loading');
    },
    callback: function () {
        $('.collection__main').removeClass('ajax-loading');
    }
});

accordionHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(cssClasses.accordionContent).first();

    $(this).toggleClass('open');
   content.slideToggle();
});

// Tag filter
const url = window.location.origin + window.location.pathname;
const filterItem = $(cssClasses.filterItem);
let collectionUrl = $(cssClasses.collectionSidebar).data('collection-url');
var productsContainer = $('.collection-grid__products');
$('.collection__active-filters').empty();
$('.refined-widgets').css('display','none');
//setTimeout(function(){$('div[data-filter="Equipment"] ul.collection-sidebar__filter-items.accordion-content').css('display','block')},500);
var count = 0;
filterItem.each(function () {
    const tag = $(this).data('tag');
	count++;
    if (url.indexOf(tag) !== -1) {
        $(this).addClass('active');
        const accordionHeading = $(this).parent().parent().find(cssClasses.accordionHeading);
      	var filterslected =  $(this).data('tag');
      	var textval =  $(this).text();
      	$(this).children('input').prop( "checked", true );
      console.log('textval');
		$('.collection__active-filters').append('<li class="filter-clear" data-tag="'+filterslected+ '"><i class="fa fa-times" aria-hidden="true"></i>'+textval+'</li>');
        if (accordionHeading.length !== 0) {
            //accordionHeading.trigger('click');
        }
       console.log('activeTagslenght1jhjhkhjjkhjkkhjkjhhjkjh');
      	 if(count >= 2){
           $('.refined-widgets').css('display','block');
      }
    }
});
$.fn.toggleCheck  =function() {
  if(this.tagName === 'INPUT') {
    $(this).prop('checked', !($(this).is(':checked')));
  }

}
$(".refined-widgets a.clear-all").click(function(e) {
  delete Shopify.queryParams.constraint;
  delete Shopify.queryParams.q;
  t.sidebarAjaxClick();
  e.preventDefault();
});
$(document).on("click",".filter-clear",function(){
    $('.collection__main').addClass('ajax-loading');
  let search = window.location.search;

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split("&")[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

	var valuetag = $(this).attr('data-tag');
  $("li[data-tag="+valuetag+"]").remove();
  var activeTags=[];
    $('.filter-clear').each(function (index, el) {
        var tag = $(el).attr('data-tag');
        var tagText = $(el).text();
        if (tag) {
            activeTags.push(tag);

          	//$('.collection__active-filters').append('<li class="filter-clear" data-tag="'+tag+ '"><i class="fa fa-times" aria-hidden="true"></i>'+tagText+'</li>');
        }

    });
  $('.refined-widgets').css('display','none');
  if(activeTags.length >= 2){
      	$('.refined-widgets').css('display','block');
      }
  console.log('valuetag',valuetag);
  var newUrl = collectionUrl;
  var tagsUrl = activeTags.join('+');
  if (tagsUrl) {
        newUrl += '/' + tagsUrl;
    }

    newUrl += search;
      $.get({
        url: newUrl,
        success: function (data) {
            var newProductsWrapper = $(data).find(".collection-grid__products");
            var newProductsHtml = newProductsWrapper.html();
            productsContainer.html(newProductsHtml);

            var newItemCount = newProductsWrapper.attr('data-products-count');
            $('.js-product-grid__count').text(newItemCount);

            var newPaginationHtml = $(data).find("#AjaxinatePagination").html();
            $('#AjaxinatePagination').html(newPaginationHtml);
            var pagination = $("#AjaxinatePagination");

            if (pagination.length) {
                pagination.html(newPaginationHtml);

                new Ajaxinate({
                    container: '#AjaxinateLoop',
                    pagination: '#AjaxinatePagination',
                    method: 'click',
                    offset: 150,
                    beforeLoad: function () {
                        $('.collection__main').addClass('ajax-loading');
                    },
                    callback: function () {
                        $('.collection__main').removeClass('ajax-loading');
                    }
                });
            }

            history.pushState({
                page: newUrl
            }, null, newUrl);

            $('.collection__main').removeClass('ajax-loading');
        }
    });
   	
});
filterItem.on('click', function () {
    let search = window.location.search;

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split("&")[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

    const filter = $(this).parents('[data-filter]');
    const filterItems = filter.find(cssClasses.filterItem);
   /* var addActiveClass = true;
    if ($(this).hasClass('active')) {
        addActiveClass = false
    }
    filterItems.removeClass('active');
    if (addActiveClass) {
        $(this).addClass('active');
    }*/

    $(this).toggleClass('active');
	$(this).children('input').toggleCheck();
   // var textval =  $(this).parent().parent().find(cssClasses.accordionHeading).text();
	
    var activeItems = $('.collection-sidebar').find(cssClasses.filterItem + '.active');
    var activeTags = [];
  	var activeText = [];
	$('.collection__active-filters').empty();
    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');
        var tagText = $(el).text();
		
        if (tag) {
            activeTags.push(tag);
          	activeText.push(tagText);
          	$('.collection__active-filters').append('<li class="filter-clear" data-tag="'+tag+ '"><i class="fa fa-times" aria-hidden="true"></i>'+tagText+'</li>');
        }

    });
 	
	    // var activeTagss = activeTags.split(",");
      //console.log('activeTagslenght',activeTags.lenght);
      if(activeTags.length >= 2){
      	$('.refined-widgets').css('display','block');
      }
    var tagsUrl = activeTags.join('+');

    var newUrl = collectionUrl;

    if (tagsUrl) {
        newUrl += '/' + tagsUrl;
    }

    newUrl += search;

    $('.collection__main').addClass('ajax-loading');

    //console.log(newUrl);
    //console.log('---',activeTags);

    $.get({
        url: newUrl,
        success: function (data) {
            var newProductsWrapper = $(data).find(".collection-grid__products");
            var newProductsHtml = newProductsWrapper.html();
            productsContainer.html(newProductsHtml);

            var newItemCount = newProductsWrapper.attr('data-products-count');
            $('.js-product-grid__count').text(newItemCount);

            var newPaginationHtml = $(data).find("#AjaxinatePagination").html();
            $('#AjaxinatePagination').html(newPaginationHtml);
            var pagination = $("#AjaxinatePagination");

            if (pagination.length) {
                pagination.html(newPaginationHtml);

                new Ajaxinate({
                    container: '#AjaxinateLoop',
                    pagination: '#AjaxinatePagination',
                    method: 'click',
                    offset: 150,
                    beforeLoad: function () {
                        $('.collection__main').addClass('ajax-loading');
                    },
                    callback: function () {
                        $('.collection__main').removeClass('ajax-loading');
                    }
                });
            }

            history.pushState({
                page: newUrl
            }, null, newUrl);
			// $('.collection-sidebar__filter-items .accordion-content').css('display','block');
            $('.collection__main').removeClass('ajax-loading');
        }
    })
});